import './App.css';
import axios from 'axios';
import { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Cart from './pages/Cart';
import Product from './pages/Product';
import CheckOut from './pages/CheckOut';
import NotFound from './pages/NotFound';
import { AuthContextProvider } from './context/AuthContext';


export default function App() {

    const [cart, setCart] = useState([]);
    const [totalCost, setTotalCost] = useState(0);
    const [totalQty, setTotalQty] = useState(0);
    const [searchTerm, setSearchTerm] = useState('spider-man');
    const [results, setResults] = useState([]);
    
    useEffect(() => {
        search(searchTerm);
    }, []);
    const search = term => {
        term = term.trim().replace(' ', '+');
        axios.get(`https://www.googleapis.com/books/v1/volumes?q=${term}?&langRestrict=en&maxResults=40&key=${process.env.REACT_APP_API_KEY}`)
        .then(res => filterResults(res.data.items))
        .catch(error => console.log(error));
    }
    const newPageCount = () => {
        return Math.ceil(Math.random() * 100 + 150);
    }
    const newPrice = () => {
        return parseFloat((Math.random() * 25 + 5).toFixed(2));
    }
    const newRating = () => {
        return parseFloat((Math.random() * 2 + 2.5).toFixed(1));
    }
    const addToCart = item => {
        if (!cart.find(i => i.id === item.id)) {
            setCart([...cart, item]);
            setTotalQty(totalQty + 1);
            setTotalCost(totalCost + item.price);
        }
    }
    const clearCart = () => {
        cart.map(item => item.qty = 1);
        setCart([]);
        setTotalCost(0);
        setTotalQty(0);
    }
    const filterResults = input => {
        setResults([]);
        input.map(item => {

            const info = item.volumeInfo;
            const price = item.saleInfo.listPrice;

            if (info.title && info.imageLinks && info.authors) {
                setResults(results => [...results, {
                    id: item.id,
                    title: info.title,
                    rating: info.averageRating || newRating(),
                    desc: info.description || 'N/A',
                    image: info.imageLinks.thumbnail,
                    author: info.authors[0],
                    length: info.pageCount || newPageCount(),
                    genre: info.categories || '',
                    price: (price) ? price.amount : newPrice(),
                    qty: 1
                }]);
            }
            return null;
        });
    }

    return (
        <AuthContextProvider>
            <Routes>
                <Route path='/' element={
                    <Home
                        search={search}
                        results={results}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        addToCart={addToCart}
                    />
                }/>
                <Route path='/products/:productId' element={
                    <Product 
                        key={':productId'}
                        results={results}
                        addToCart={addToCart}
                    />}
                    
                />
                <Route path='/cart' element={
                    <Cart
                        cart={cart}
                        setCart={setCart}
                        totalCost={totalCost}
                        setTotalCost={setTotalCost}
                        totalQty={totalQty}
                        setTotalQty={setTotalQty}
                    />
                }/>
                <Route path='/checkout' element={
                    (cart.length) ? (
                        <CheckOut cart={cart} clearCart={clearCart}/>
                    ) : (
                        <Navigate to='/' />
                    )
                }/>
                <Route path='*' element={<Navigate to='/' />}/>
            </Routes>
        </AuthContextProvider>
    );
}
